//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientGraphQLAuthMutation, clientQuery } from 'Core/data/GraphQLApi';
import { clientPOST } from 'Core/data/RestApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    CONFIRM_USER_REQUEST,
    CONFIRM_USER_VERIFICATE_CODE_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    confirmUserResult,
    confirmUserVerificateCodeResult
} from 'Redux/actions';

function* confirmUserRequest({ payload }) {
    try {
        const { username, code, password, navigate, type } = payload;
        let data = yield call(
            clientGraphQLAuthMutation,
            `
               mutation (
                    $code: String!
                    $password: String!
                    $username: String!
                    $type: enumCodeType
                ){
                    result: verifyUser (
                        username: $username
                        code: $code
                        password: $password
                        type: $type
                    ) {
                        success
                        message
                    }
                }
            `,
            {
                username,
                code,
                password,
                type
            }
        );

        if (data.result.success) {
            yield put(confirmUserResult(data.result, null));
            navigate('/login');
        } else {
            yield put(confirmUserResult(data.result, null));
        }
    } catch (exc) {
        ExceptionManager(exc, 'Core/views/confirmUser/redux', 'confirmUserRequest')
        yield put(confirmUserResult(null, exc));
    }
}

function* confirmUserVerificateCodeRequest({ payload }) {
    try {
        const { username, code, type } = payload;
        let data = yield call(
            clientGraphQLAuthMutation,
            `
               query (
                    $code: String!
                    $username: String!
                    $type: enumCodeType
                ){
                    result: validateCode (
                        username: $username
                        code: $code
                        type: $type
                    ) {
                        registrationStatus
                        isValid
                    }
                }
            `,
            {
                code,
                username,
                type
            }
        );
        
        yield put(confirmUserVerificateCodeResult(data.result, null));
    } catch (exc) {
        ExceptionManager(exc, 'Core/views/confirmUser/redux', 'confirmUserVerificateCodeRequest')
        yield put(confirmUserVerificateCodeResult(null, exc));
    }
}


function* watchLoginRequests() {
    yield takeEvery(CONFIRM_USER_REQUEST, confirmUserRequest);
    yield takeEvery(CONFIRM_USER_VERIFICATE_CODE_REQUEST, confirmUserVerificateCodeRequest);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchLoginRequests)
    ]);
}
